import * as _ from 'lodash';

export class NumberFilterUtils {
  static loadTemplate(template) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = template;
    return tempDiv.firstChild;
  }

  static addChangeListener(element, listener) {
    element.addEventListener('changed', listener);
    element.addEventListener('paste', listener);
    element.addEventListener('input', listener);
    // IE doesn't fire changed for special keys (eg delete, backspace), so need to
    // listen for this further ones
    element.addEventListener('keydown', listener);
    element.addEventListener('keyup', listener);
  }

  static removeElement(parent, cssSelector) {
    let node = parent.querySelector(cssSelector);
    if (node && node.parentNode) {
      node.parentNode.removeChild(node);
    }
  }

  static standardizeValue(value) {
    if (_.isString(value)) {
      value = value.trim();
    }

    if (value === null || value === undefined || value === '') {
      return null;
    } else {
      return parseFloat(value);
    }
  }
}
